<template>
    <div id="oneKeeper" class="oneKeeper">
        <router-view></router-view>
    </div>
</template>

<script>
    const log = new Log("Page/oneKeeper");
    export default {
        name: "oneKeeper"
    }
</script>

<style lang="less">
    #oneKeeper {
        position: relative;
        overflow: hidden;
        width: 100%;
        padding: 10px 0;
        border-radius: 5px;
        background-color: #ffffff
    }
</style>